import _slicedToArray from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getGlslDifferences } from '../../glsl_version';
export var FromPixelsProgram = /*#__PURE__*/_createClass(function FromPixelsProgram(outputShape) {
  _classCallCheck(this, FromPixelsProgram);

  this.variableNames = ['A'];
  var glsl = getGlslDifferences();

  var _outputShape = _slicedToArray(outputShape, 2),
      height = _outputShape[0],
      width = _outputShape[1];

  this.outputShape = outputShape;
  this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(".concat(width, ".0, ").concat(height, ".0);\n\n        vec4 values = ").concat(glsl.texture2D, "(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    ");
});